import { appendSecuritySlide } from './reportSecurityExport';

export function appendQualitySlide(pptx, data) {
  const review = data?.quality_review || {};
  const slide = pptx.addSlide();
  slide.background = { color: 'F8FAFC' };
  slide.addText('Report consistency & evidence check', { x: 0.5, y: 0.4, w: '90%', h: 0.5, fontSize: 22, bold: true, color: '153E35' });
  const status = (review.status || 'not_checked').replaceAll('_', ' ');
  const lines = [
    `Status: ${status} · ${review.critical_count || 0} critical findings · ${review.warning_count || 0} limitations`,
    review.summary || 'This report has not been checked with the current rubric.',
    review.scope || 'AI review is not independent authentication of facts or an audit certification.',
    ...(review.findings || []).slice(0, 5).map(f => `${f.severity}: ${f.message}`),
    `Rubric: ${review.rubric_version || 'Not available'} · Reviewer: ${review.judge_model || 'Not available'}`,
    `Input: ${(review.input_hash || 'Not available').slice(0, 16)} · Output: ${(review.output_hash || 'Not available').slice(0, 16)}`,
  ];
  slide.addText(lines.join('\n\n'), { x: 0.5, y: 1.1, w: '90%', h: 4, fontSize: 12, color: '273D35', breakLine: false, fit: 'shrink', valign: 'top' });
  appendSecuritySlide(pptx);
}